import React from 'react';

import { useDisplayNameFormatter } from './useDisplayNameFormatter';

export type BaseUser = {
  displayName?: string,
  firstName?: string,
  lastName?: string,
}

type DisplayNameFormatterProps = {
  user?: BaseUser
}

const DisplayNameFormatter: React.FC<DisplayNameFormatterProps> = ({ user = {} }) => {
  const formatter = useDisplayNameFormatter();

  return (
    <React.Fragment>
      {formatter(user)}
    </React.Fragment>);
};

export default DisplayNameFormatter;
